import StepCategories from './stepCategories.view';

export default StepCategories;
